import { Editor, Element, Text, Transforms } from "slate";

const CustomEditor = {
  isBoldMarkActive(editor) {
    const [match] = Editor.nodes(editor, {
      match: (n) => n.bold === true,
      universal: true,
    });

    return !!match;
  },

  isItalicMarkActive(editor) {
    const [match] = Editor.nodes(editor, {
      match: (n) => n.italic === true,
      universal: true,
    });

    return !!match;
  },

  isShouldDeleteMarkActive(editor) {
    const [match] = Editor.nodes(editor, {
      match: (n) => n.delete?.id,
      universal: true,
    });

    return !!match;
  },

  isDicoMarkActive(editor) {
    const [match] = Editor.nodes(editor, {
      match: (n) => n.dico,
      universal: true,
    });

    return !!match;
  },

  isDicoMarkActiveAt(editor, at) {
    const [match] = Editor.nodes(editor, {
      match: (n) => n.dico,
      universal: true,
      at,
    });

    return !!match;
  },

  isCodeBlockActive(editor) {
    const [match] = Editor.nodes(editor, {
      match: (n) => n.type === "code",
    });

    return !!match;
  },

  isSpeakerBlockActive(editor) {
    const [match] = Editor.nodes(editor, {
      match: (n) => n.type === "speaker",
    });

    return !!match;
  },

  isImageBlockActiveAt(editor, at) {
    const [match] = Editor.nodes(editor, {
      match: (n) => n.type === "image",
      at,
    });

    return !!match;
  },

  toggleBoldMark(editor) {
    const isActive = CustomEditor.isBoldMarkActive(editor);
    Transforms.setNodes(
      editor,
      { bold: isActive ? null : true },
      { match: (n) => Text.isText(n), split: true }
    );
  },

  toggleItalicMark(editor) {
    console.log("toggle italic");
    const isActive = CustomEditor.isItalicMarkActive(editor);
    Transforms.setNodes(
      editor,
      { italic: isActive ? null : true },
      { match: (n) => Text.isText(n), split: true }
    );
  },

  toggleShouldDeleteMark(editor) {
    console.log("toggle should delete");
    const isActive = CustomEditor.isShouldDeleteMarkActive(editor);
    Transforms.setNodes(
      editor,
      { delete: isActive ? null : { id: new Date().getTime() } },
      { match: (n) => Text.isText(n), split: true }
    );
  },

  toggleDicoMark(editor, dico) {
    console.log(dico);
    const isActive = CustomEditor.isDicoMarkActiveAt(editor);
    Transforms.setNodes(
      editor,
      {
        dico: isActive ? null : dico,
      },
      { match: (n) => Text.isText(n), split: true }
    );
  },

  toggleDicoMarkAt(editor, at, dico) {
    console.log(dico);
    const isActive = CustomEditor.isDicoMarkActiveAt(editor);
    console.log(isActive);
    Transforms.setNodes(
      editor,
      {
        dico: isActive ? null : dico,
      },
      { match: (n) => Text.isText(n), split: true, at }
    );
  },

  toggleCodeBlock(editor) {
    const isActive = CustomEditor.isCodeBlockActive(editor);
    Transforms.setNodes(
      editor,
      { type: isActive ? "paragraph" : "code" },
      {
        match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
      }
    );
  },

  toggleSpeakerBlock(editor) {
    const isActive = CustomEditor.isSpeakerBlockActive(editor);
    Transforms.setNodes(
      editor,
      {
        type: isActive ? "paragraph" : "speaker",
        speaker: isActive ? null : "Toto",
      },
      {
        match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
      }
    );
  },

  setSpeaker(editor, perso, element, changeAll) {
    if (changeAll) {
      const generator = Editor.nodes(editor, {
        at: {
          anchor: Editor.start(editor, []),
          focus: Editor.end(editor, []),
        },
        match: (n) => n.speaker && n.speaker.name === element.speaker.name,
      });

      for (const m of generator) {
        Transforms.setNodes(
          editor,
          {
            type: "speaker",
            speaker: perso,
          },
          {
            at: m[1],
            match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
          }
        );
      }
    } else
      Transforms.setNodes(
        editor,
        {
          type: "speaker",
          speaker: perso,
        },
        {
          match: (n) => Element.isElement(n) && Editor.isBlock(editor, n),
        }
      );
  },

  insertImage(editor, url) {
    const element = { type: "image", url, children: [{ text: "" }] };
    Transforms.insertNodes(editor, element);
  },
  insertImageAt(editor, at, url) {
    const element = { type: "image", url, children: [{ text: "" }] };
    Transforms.insertNodes(editor, element, { at });
  },
  updateImageAt(editor, at, url) {
    const isActive = CustomEditor.isImageBlockActiveAt(editor, at);
    if (isActive)
      Transforms.setNodes(
        editor,
        {
          url,
        },
        {
          at,
        }
      );
  },

  removeImage(editor, path) {
    Transforms.removeNodes(editor, { at: path });
  },
};

export default CustomEditor;
